import { useState } from "react";
import { ArrowDownWideNarrow, MessageCircle, Plus, UserX } from "lucide-react";
import { isManual } from "@/lib/order";
import { SortableList } from "./SortableList";
import { AbsentBadge } from "./AbsentBadge";

export const GridCell = ({ employee, day, tasks, color, isToday, h }) => {
  const [over, setOver] = useState(false);
  const absence = h.absenceFor(employee.id, day.iso);
  const onDrop = (e) => {
    e.preventDefault();
    setOver(false);
    const id = e.dataTransfer.getData("text/plain");
    if (id && !e.nativeEvent.reorderHandled) h.move(id, employee.id, day.iso);
  };
  const slot = `${employee.id}-${day.idx}`;

  return (
    <div
      data-testid={`cell-${slot}`}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={onDrop}
      className={`grid-cell ${over ? "is-over" : ""} ${absence ? "is-absent" : ""}`}
      style={{ background: isToday ? color.bg : color.soft, borderColor: color.border, "--accent": color.accent }}
    >
      {absence && <AbsentBadge testId={`cell-absent-${slot}`} onRemove={() => h.removeAbsence(absence, employee, day)} removeTestId={`cell-unabsent-${slot}`} />}
      <div className="flex flex-col gap-1.5">
        <SortableList tasks={tasks} h={h} />
      </div>
      {!absence && (
        <div className="cell-actions">
          <button type="button" data-testid={`cell-add-${slot}`} onClick={() => h.add(employee.id, day.iso)} className="cell-add" style={{ color: color.ink }} aria-label={`Aggiungi attività per ${employee.name} ${day.name}`}>
            <Plus className="h-3.5 w-3.5" /> Aggiungi
          </button>
          {tasks.length > 0 && (
            <button type="button" data-testid={`cell-share-${slot}`} onClick={() => h.shareDay(employee, day)} className="cell-icon cell-share" title="Invia la giornata su WhatsApp" aria-label={`Invia la giornata di ${employee.name} su WhatsApp`}>
              <MessageCircle className="h-3.5 w-3.5" />
            </button>
          )}
          {isManual(tasks) && (
            <button type="button" data-testid={`cell-sort-${slot}`} onClick={() => h.resetOrder(tasks)} className="cell-icon cell-absent-btn" title="Ordina per priorità" aria-label="Ordina per priorità">
              <ArrowDownWideNarrow className="h-3.5 w-3.5" />
            </button>
          )}
          <button type="button" data-testid={`cell-absent-btn-${slot}`} onClick={() => h.markAbsent(employee, day)} className="cell-icon cell-absent-btn" title="Segna assente" aria-label={`Segna ${employee.name} assente ${day.name}`}>
            <UserX className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    </div>
  );
};
